<template>
  <component :is="userComponent"/>
</template>

<script>
  import PCIndex from '@/views/pc/Index'
  import MobileIndex from '@/views/mobile/Index'

  export default {
    computed: {
      userComponent() {
        return this.ua == 'pc' ? PCIndex : MobileIndex
      }
    },

    created() {
      this.ua = localStorage.getItem("ua") || "pc"
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Index.vue